// Backend identifiers are positive Int32 values, not project/company aliases.
export function canonicalBackendId(value) {
	if (typeof value !== "number" && typeof value !== "string") return null;
	const decimal = String(value);
	if (!decimal.length || /[^0-9]/.test(decimal)) return null;
	const id = Number(value);
	return Number.isSafeInteger(id) && id > 0 && id <= 2147483647 ? id : null;
}

// Only the immediate same-origin launcher is a supported source of partner context.
// null means ordinary Builder navigation; a null partnerId means a recognized but invalid launch.
export function getIframePartnerContext(windowObject = window) {
	try {
		const parent = windowObject.parent;
		if (!parent || parent === windowObject || parent.location.origin !== windowObject.location.origin) return null;
		const pathname = parent.location.pathname;
		const match = /^\/brands\/([^/]*)\/builder\/?$/.exec(pathname);
		return match && match[0] === pathname ? { partnerId: canonicalBackendId(match[1]) } : null;
	} catch {
		// Cross-origin frames cannot supply trusted context.
		return null;
	}
}
